import React from "react";
import { Modal, Row, Col, Form, Button, notification } from "antd";
import { compose } from "recompose";
import { withApollo } from "react-apollo";
import { withGlobal } from "../../../../component-global";
import { CustomRow } from "../../../../components/Grid";
import { deleteAffiliates } from "../../../../graphQl/mutations/affiliate";
import { BtnDangerPrimary, AGENCY_PORTAL_CLASS } from "./style";

class ModalDeleteAffiliate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingButtons: false,
    };
  }

  mutationDeleteAffiiliates = async () => {
    const { dataSelected, onHandleCancelModal, loadTable } = this.props;

    try {
      const variables = {
        userIDs: (dataSelected || []).map(obj => obj.userID),
      };
      this.setState({ loadingButtons: true });
      this.props.client
        .mutate({
          mutation: deleteAffiliates,
          update: (cache, { data: { deleteAffiliates: response } }) => {
            response.statusCode === 200
              ? notification.success({ message: response.message })
              : notification.error({ message: response.message });
            loadTable();
            onHandleCancelModal();
          },
          variables,
        })
        .catch(() => {
          this.setState({ loadingButtons: false });
          notification.error({
            message: "Hubo un error al actualizar los datos.",
          });
        });
    } catch (err) {
      this.setState({ loadingButtons: false });
      notification.error({
        message: "Hubo un error al actualizar los datos.",
      });
    }
  };

  closeModal = () => {
    const { onHandleCancelModal } = this.props;
    const { loadingButtons } = this.state;
    if (!loadingButtons) onHandleCancelModal();
  };

  render = () => {
    const { visible, onHandleCancelModal } = this.props;
    const { loadingButtons } = this.state;

    const authEditDrawer = this.props.permissionsView
      ? this.props.permissionsView.edit
      : false;

    return (
      <Modal
        title={null}
        visible={visible}
        footer={null}
        onCancel={this.closeModal}
        width="470px"
        wrapClassName={AGENCY_PORTAL_CLASS}
        bodyStyle={{ height: "210px", fontFamily: "Gilroy, sans-serif" }}
      >
        <div style={{ textAlign: "center" }}>
          <p
            style={{
              fontFamily: "Gilroy, sans-serif",
              fontWeight: "bold",
              fontSize: "20px",
              lineHeight: "32px",
              textAlign: "center",
              color: "#595959",
              marginBottom: 20,
            }}
          >
            Eliminar afiliado(s)
          </p>
        </div>
        <Row gutter={16} style={{ marginBottom: 15 }}>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={24}
            style={{ marginBottom: 0 }}
          >
            <p
              style={{
                fontFamily: "Gilroy, sans-serif",
                fontSize: "14px",
                lineHeight: "32px",
                textAlign: "center",
                color: "#595959",
                marginBottom: 0,
              }}
            >
              Esta seguro que desea eliminar los afiliados seleccionadas?.
            </p>
          </Col>
        </Row>

        <CustomRow gutter={24} type="flex" justify="space-around">
          <Col xs={24} sm={24} md={4} lg={4} xl={4} />
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <Button
              size="large"
              style={{
                width: "100%",
                fontFamily: "Gilroy, sans-serif",
                fontWeight: "600",
                fontSize: "14px",
              }}
              onClick={onHandleCancelModal}
              loading={loadingButtons}
            >
              No
            </Button>
          </Col>
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <BtnDangerPrimary
              type="primary"
              size="large"
              style={{
                width: "100%",
                fontFamily: "Gilroy, sans-serif",
                fontWeight: "600",
                fontSize: "14px",
              }}
              onClick={this.mutationDeleteAffiiliates}
              loading={loadingButtons}
              disabled={!authEditDrawer}
            >
              Si
            </BtnDangerPrimary>
          </Col>
          <Col xs={24} sm={24} md={4} lg={4} xl={4} />
        </CustomRow>
      </Modal>
    );
  };
}

const WraperModalDeleteAffiliate = withGlobal(ModalDeleteAffiliate);
const ModalDeleteAffiliateForm = Form.create()(WraperModalDeleteAffiliate);

export default compose(withApollo)(ModalDeleteAffiliateForm);
